var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoucherFill = function SvgVoucherFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Voucher-Fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8BCC8",
    d: "M2.354 19.643A2.355 2.355 0 0 1 0 17.286v-3.19a.786.786 0 0 1 .586-.76 2.415 2.415 0 0 0 0-4.673A.786.786 0 0 1 0 7.904v-3.19a2.355 2.355 0 0 1 2.354-2.357h17.292A2.355 2.355 0 0 1 22 4.714v3.197a.785.785 0 0 1-.58.759 2.415 2.415 0 0 0 0 4.66.785.785 0 0 1 .58.76v3.196a2.355 2.355 0 0 1-2.354 2.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m15.655 7.766-7.857 7.857a.982.982 0 0 1-1.388-1.389l7.858-7.857a.982.982 0 1 1 1.387 1.389m-7.764-1.48a1.571 1.571 0 1 0 0 3.143 1.571 1.571 0 0 0 0-3.143m6.286 6.285a1.571 1.571 0 1 0 0 3.143 1.571 1.571 0 0 0 0-3.143",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Voucher-Fill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgVoucherFill;